// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1qC_6","insightsList":"newBusinessInsightsMenu_insightsList__3RnDF","active":"newBusinessInsightsMenu_active__2Nf0F"};